import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {WeblinkUserService} from '../shared/weblink-user.service';
import {MediaQueryService} from "@docma-weblink/shared/responsive/services/media-query.service";
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-weblink-header',
  templateUrl: './weblink-header.component.html',
  styleUrls: ['./weblink-header.component.scss']
})
export class WeblinkHeaderComponent implements OnInit {

  currentUser: string;

  @Output() onChangeUser : EventEmitter<string>= new EventEmitter<string>();

  constructor(private userService: WeblinkUserService, public mediaQueryService: MediaQueryService, public appComponent: AppComponent) {

    this.currentUser= this.userService.getCurrentUser();
    this.userService.onUserChange.subscribe((u:string)=>{
      this.currentUser=u;
    });
   }

  ngOnInit() {
  }

  logout(){
    this.userService.setCurrentUser(null);
  }

  changeUser(){
    this.onChangeUser.emit(this.currentUser);
  }

}
